import { createReducer } from '@api/createRequestStore';
import { SCOPE } from './types';

export { default as selectors } from './selectors';
export { default as sagas } from './sagas';

export const reducer = createReducer(SCOPE);

export { SCOPE };
